/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useContext, useMemo } from "react";
import { LocationsContext } from "../../pages/locations";

export const LocationIntegrationCheckbox = ({ integration, checked, onChange }) => {
  const { information } = useContext(LocationsContext);
  const name = useMemo(() => `integration-${integration.id}-check`, [integration]);

  return (
    <label htmlFor={name}>
      <span>
        <input
          id={name}
          data-testid={name}
          name={integration.id}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={!information.openForm}
        />
        {integration.name}
      </span>
    </label>
  );
};

const WithMetaField = (Component) =>
  function LocationMetaField({ metas, metaKey, label, tag, onChange, ...props }) {
    const { information } = useContext(LocationsContext);
    const meta = useMemo(() => metas.find(({ metaKey: mKey }) => mKey === metaKey) || {}, [metas]);
    const internal_onChange = (e) =>
      onChange(e, { metaKey, metaValue: e.target.value.trim(), metaType: tag });
    const childProps = {
      name: meta.metaKey || metaKey,
      value: meta.metaValue,
      disabled: !information.openForm,
      onChange: internal_onChange,
      ...props,
    };
    return (
      <div className="col col100">
        <label>
          <span>{label}</span>
          <Component {...childProps} />
        </label>
      </div>
    );
  };

const MetaFieldInput = ({ name, value, disabled, onChange, type, placeholder }) => (
  <input
    id={`meta-field-${name}-txt`}
    data-testid={name}
    name={name}
    type={type}
    disabled={disabled}
    defaultValue={value}
    placeholder={placeholder}
    onChange={onChange}
  />
);

const MetaFieldDropdown = ({ name, value, disabled, onChange, optionList }) => {
  return (
    <select
      id={`meta-field-${name}-select`}
      name={name}
      disabled={disabled}
      onChange={onChange}
      value={value || ""}
      data-testid={name}
    >
      <option value="">Select an environment...</option>
      {optionList.map(({ displayName, value: itemValue }, i) => (
        <option key={i} value={itemValue}>
          {displayName}
        </option>
      ))}
    </select>
  );
};

export const LocationMetaInput = WithMetaField(MetaFieldInput);
export const LocationMetaDropdown = WithMetaField(MetaFieldDropdown);
